export const GET_ALBUM = 'GET_ALBUM';
export const GET_ALBUM_SUCCESS = 'GET_ALBUM_SUCCESS';
export const GET_ALBUM_DETAIL = 'GET_ALBUM_DETAIL';
export const GET_ALBUM_DETAIL_SUCCESS = 'GET_ALBUM_DETAIL_SUCCESS';
export const DETETE_ALBUM_REQUEST = 'DETETE_ALBUM_REQUEST';
export const DETETE_ALBUM_SUCCESS = 'DETETE_ALBUM_SUCCESS';

export const RESET_ALBUM_SUCCESS = 'RESET_ALBUM_SUCCESS';
export const UPDATE_ALBUM_BADGE_COUNT = 'UPDATE_ALBUM_BADGE_COUNT';
export const RESET_DATA_ALBUM_SUCCESS = 'RESET_DATA_ALBUM_SUCCESS';
